var map = {
	"./htkac_landing_1920x1200.jpg": 6252,
	"./longest-word_landing_1920x1200.jpg": 149,
	"./rar_landing_1920x1200.jpg": 9824,
	"./substracked_logged-in_1920x1200.jpg": 2170,
	"./watchlist_landing_1920x1200.jpg": 3673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7256;